import { useQuery } from '@tanstack/react-query'
import { supabase } from '../../api'

const getProfileId = async () => {
  const { data, error } = await supabase
    .from('user_profiles')
    .select(`*,
      expertProfile:salons_profile (*)`)
    .not('expert_id', 'is', null)
    .order('created_at', { ascending: false })

  if (error) {
    throw new Error(error.message)
  }

  return data
}

export default function useGetExperts() {
  return useQuery({
    queryKey: ['useGetExperts'],
    queryFn: () => getProfileId(),
    staleTime: 0,
  })
}
